import React from "react";
import { format } from "date-fns";
import { cn } from "@/lib/utils";

interface TimelinePointProps {
  label: string;
  date: Date | string | number;
  isActive?: boolean;
  align?: "start" | "center" | "end";
}

export const TimelinePoint = ({
  label,
  date,
  isActive,
  align = "center",
}: TimelinePointProps) => {
  const formattedDate = format(new Date(date), "dd MMMM yyyy");

  const alignmentClasses = {
    start: "items-start text-left",
    center: "items-center text-center",
    end: "items-end text-right",
  };

  return (
    <div
      className={cn("relative flex flex-1 flex-col", alignmentClasses[align])}
    >
      <div
        className={cn(
          "z-10 size-3 rounded-full border border-neutral-300 bg-white shadow-sm transition-colors",
          {
            "border-royal-glow-3 bg-royal-glow-3": isActive,
          },
        )}
      />

      <div className="mt-4">
        <p className="mb-1.5 text-xs leading-none font-medium text-neutral-400">
          {label}
        </p>
        <p className="text-eathy-comfort-1 text-sm leading-none font-medium">
          {formattedDate}
        </p>
      </div>
    </div>
  );
};
